/** The five tiers, lowest trust first; mirrors `TRUST_TIERS` in core. */
export const TRUST_TIER_LABELS: Record<string, string> = {
  untrusted: "untrusted",
  trusted: "trusted",
  trusted_7d: "trusted · 7d",
  trusted_30d: "trusted · 30d",
  super_trusted: "super trusted",
};
